import React from 'react';
import styles from './_lease-quoter-solve-button.module.scss';
import CalculateIcon from "@mui/icons-material/Calculate";
import { Button } from "@progress/kendo-react-buttons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { IApplication } from "../../../../Interfaces/Application/IApplication";
import { useLeaseQuoteSolve } from "../../../../hooks/UseLeaseQuoteSolve";

export interface LeaseQuoterSolveButtonProps {
  currentApp: IApplication;
  buttonName: "Roll Back" | "Quote / Solve";
}

export default function LeaseQuoterSolveButton(props: LeaseQuoterSolveButtonProps) {
  const { solve } = useLeaseQuoteSolve();
  const mode = props.buttonName === "Roll Back" ? "RollBack" : "Quote";

  return (
    <div className={styles.leaseQuoterSolveButtonContainer}>
      <Tooltip anchorElement="target" position="top" parentTitle={true}>
        <Button
          title={props.buttonName}
          themeColor="primary"
          onClick={() => solve(props.currentApp, mode)}
          style={{ padding: 3, paddingLeft: 10, paddingRight: 10, marginLeft: 4, whiteSpace: "nowrap" }}
        >
          <CalculateIcon style={{ marginRight: 2 }} fontSize="small" />
          {props.buttonName}
        </Button>
      </Tooltip>
    </div>
  );
}
